module.exports = "/fonts/NunitoSans-SemiBold.33173a92298c549adfd1bcdcd0f3956a.ttf";